import * as React from "react";
import { styled } from "theme";
import { motion } from "framer-motion";

export interface SwitchProps {
  id?: string;
  isChecked: boolean;
  isDisabled: boolean;
  onChange: (b: boolean) => void;
  children: React.ReactNode;
}

const variants = {
  checked: {
    borderRadius: "2px"
  },
  unchecked: {
    borderRadius: "50%"
  }
};

const outerVariants = {
  checked: {
    borderRadius: "3px"
  },
  unchecked: {
    borderRadius: "50%"
  }
};

const Switch: React.FC<SwitchProps> = ({ id, isChecked, isDisabled, onChange, children }) => {
  let cn = [];
  if (isChecked) cn.push("active");
  if (isDisabled) cn.push("disabled");
  return (
    <Container animate={isChecked ? "checked" : "unchecked"}>
      <InnerContainer>
        <TheSwitch>
          <SwitchContainer variants={outerVariants} className={cn.join(" ")}>
            <Toggle
              className={cn.join(" ")}
              whileHover={{ scale: 1.1, opacity: 0.8 }}
              whileTap={{ scale: 0.9 }}
              onClick={(e: any) => {
                e.preventDefault();
                if (!isDisabled) {
                  onChange(!isChecked);
                }
              }}
              variants={variants}
            />
          </SwitchContainer>
        </TheSwitch>
        <Content>{children}</Content>
      </InnerContainer>
    </Container>
  );
};

export default Switch;

const _Container = styled.div`
  flex: 1;
`;

const Container = motion.custom(_Container);

const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

const Content = styled.div`
  flex: 1 1 auto;
`;

const TheSwitch = styled.div`
  flex: 0 0 44px;
`;

const _SwitchContainer = styled.div`
  width: 24px;
  height: 24px;
  background-color: ${(props) => props.theme.colors.gray["800"]};

  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
  }
`;
const SwitchContainer = motion.custom(_SwitchContainer);

const _Toggle = styled.button`
  width: 20px;
  height: 20px;
  margin: 2px;
  background-color: #fff;

  border: 0;
  outline: 0;

  &.active {
    background-color: ${(props) => props.theme.colors.green["400"]};
    margin: 2px;
    width: 20px;
    height: 20px;
  }

  &.disabled {
    opacity: 0.3;
  }
`;

const Toggle = motion.custom(_Toggle);
